import React from 'react'
import { Box, Typography, LinearProgress } from '@mui/material'

interface Props {
  label: string
  value: number
  color: string
}

const MetricRow: React.FC<Props> = ({ label, value, color }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 0.85 }}>
    <Typography
      sx={{
        fontFamily: 'PremierLeagueRegular',
        fontSize: '0.76rem',
        opacity: 0.65,
        whiteSpace: 'nowrap',
        minWidth: 116,
      }}
    >
      {label}
    </Typography>
    <LinearProgress
      variant="determinate"
      value={value * 10}
      sx={{
        flex: 1,
        height: 6,
        borderRadius: 3,
        backgroundColor: 'rgba(128,128,128,0.13)',
        '& .MuiLinearProgress-bar': { borderRadius: 3, backgroundColor: color },
      }}
    />
    <Typography
      sx={{
        fontFamily: 'PremierLeagueBold',
        fontSize: '0.78rem',
        color,
        minWidth: 28,
        textAlign: 'right',
      }}
    >
      {Math.round(value * 10)}
    </Typography>
  </Box>
)

export default MetricRow
